import { useEffect, useState } from 'react';

import { authStorage } from 'utils/storage';

export function useAuthStatus() {
  const [isAuthenticated, setIsAuthenticated] = useState(() => authStorage.hasToken());

  useEffect(() => {
    const updateAuth = () => setIsAuthenticated(authStorage.hasToken());

    window.addEventListener('storage', updateAuth);
    window.addEventListener('auth-change', updateAuth);
    window.addEventListener('focus', updateAuth);
    document.addEventListener('visibilitychange', updateAuth);

    const intervalId = setInterval(updateAuth, 10000);

    return () => {
      window.removeEventListener('storage', updateAuth);
      window.removeEventListener('auth-change', updateAuth);
      window.removeEventListener('focus', updateAuth);
      document.removeEventListener('visibilitychange', updateAuth);
      clearInterval(intervalId);
    };
  }, []);

  return isAuthenticated;
}
